module.exports = __webpack_public_path__ + "static/media/12.6bfc4f66.mp3";